import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container-fix-padding" }

import { onMounted } from 'vue'
import MyprofileUpdate from '../organisms/MyprofileUpdate.vue'
import { headerState } from '../../stores/header'


export default /*@__PURE__*/_defineComponent({
  __name: 'MyProfile',
  setup(__props) {

onMounted(async () => {
  headerState.setTitle('マイプロファイル')
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(MyprofileUpdate)
  ]))
}
}

})